import { createSelector } from 'reselect';
import UrlHelper from '../../domain/UrlHelper';
import { getEntities, selectPathname } from '../../global-selectors';
import { selectUserData } from './user';

const extractContentId = (id) => {
  if (id && id.indexOf('_') >= 0) {
    return id.split('_')[1];
  }

  return id;
};

export const selectContents = createSelector(
  getEntities,
  entities => entities.contents || {}
);

export const selectCurrentContentPath = createSelector(
  selectPathname,
  pathname => pathname.split('/')[2]
);

export const selectCurrentContentId = createSelector(
  selectCurrentContentPath,
  contentId => extractContentId(contentId),
);

export const selectCurrentContent = createSelector(
  selectContents,
  selectCurrentContentId,
  (contents, contentId) => contents[contentId] || {}
);

export const selectCurrentContentPpvConfig = createSelector(
  selectCurrentContent,
  (content) => content.ppvConfig
);

export const selectCurrentContentPpvId = createSelector(
  selectCurrentContentPpvConfig,
  (ppvConfig) => (ppvConfig || {}).ppvId
);

export const selectCurrentContentFichaPath = createSelector(
  selectUserData,
  selectCurrentContent,
  (user, content) => (
    (user && user.country) && UrlHelper.setCountryCode(user.country).buildFichaPathFromContent(content)
  )
);

export const selectCurrentContentPlayerPath = createSelector(
  selectUserData,
  selectCurrentContent,
  (user, content) => (
    UrlHelper.setCountryCode(user.country).buildPlayPathFromContent(content)
  )
);
